import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MatPaginator, MAT_DIALOG_DATA, PageEvent } from '@angular/material';
import { Router } from '@angular/router';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PremissasService } from 'src/app/services/premissas.service';
import { ProdutoService } from 'src/app/services/produto.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { EstoqueProdutoModalComponent } from '../estoque-produto-modal/estoque-produto-modal.component';
import { PedidosLoteModalComponent } from '../pedidos-lote-modal/pedidos-lote-modal.component';
import { Produto } from './../../models/produto';
import { Fornecedor } from 'src/app/models/fornecedor';
import { FornecedorService } from 'src/app/services/fornecedor.service';
import { FuncionarioService } from 'src/app/services/funcionario.service';
import { HistoricoDoPrecoModalComponent } from '../historico-do-preco-modal/historico-do-preco-modal.component';
import { PaginatorService } from 'src/app/services/paginator.service';
import { HistoricoEstoqueModalComponent } from '../historico-estoque-modal/historico-estoque-modal.component';
import { GlobalService } from 'src/app/services/global.service';
import { Categoria } from "../../models/categoria";
import { CategoriaService } from "../../services/categoria.service";

// jquery
declare const $: any;

@Component({
  selector: 'app-estoque-modal',
  templateUrl: './estoque-modal.component.html',
  styleUrls: ['./estoque-modal.component.scss']
})
export class EstoqueModalComponent implements OnInit, OnDestroy {

  // variáveis
  produtosFiltrados: Produto[] = [];
  carregando = true;
  campoOrdenacao = 'descricao';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  filtroDescricao = '';
  filtroCodBarras = '';
  status = [{ id: '', nome: 'Todos' }, { id: 'A', nome: 'Ativo' }, { id: 'B', nome: 'Bloqueado' }];
  statusSelecionado = 'A';
  familias = [{ id: -1, nome: 'Todos' }, { id: 2, nome: 'Painel' }, { id: 3, nome: 'Inversor' }, { id: 4, nome: 'Stringbox' },
  { id: 5, nome: 'Cabo' }, { id: 6, nome: 'Estrutura' }, { id: 8, nome: 'Transformador'}, { id: 9, nome: 'Bateria'}, { id: 1, nome: 'Outros' }];
  familiaSelecionada = -1;

  categorias: Categoria[] = [];
  categoriaSelecionada: undefined;

  mostrarCodErp: false;

  statusCD = [{ id: '', nome: 'Todos' }, { id: 'A', nome: 'Ativo' }, { id: 'B', nome: 'Bloqueado' }];
  statusCDSelecionado = 'A';

  vendaProgramada = false;

  multiFornecedores = false;
  pCentroDistribuicao = false;

  fornecedores: Fornecedor[] = [];

  fornecedorSelecionado;

  estoqueVirtual = false;

  reservaManual = false;

  verExcel = false;

  public config: PerfectScrollbarConfigInterface = {};

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(private produtoService: ProdutoService, public utilitarioService: UtilitarioService, private premissasService: PremissasService,
    private router: Router, private carregandoService: CarregandoService, private notificacaoService: NotificacaoService,
    private funcionarioService: FuncionarioService, private paginatorService: PaginatorService, private globalService: GlobalService,
    public dialogRef: MatDialogRef<EstoqueModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog, private fornecedorService: FornecedorService, private categoriaService: CategoriaService) { }

  async ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.verExcel = (await this.globalService.consultaUsuario()).verExcel;

    await this.buscarVendaProgramada();
    await this.buscarMultiFornecedores();
    await this.buscarPremissaCentroDeDistribuicao();
    await this.buscarReservaManual();

    if (this.pCentroDistribuicao) {
      await this.buscarIdCDPadrao();
    }

    if (this.multiFornecedores || this.pCentroDistribuicao) {
      await this.buscarFornecedores();
    }

    this.buscarMostrarCodErp();
    this.buscarProdutos();
    this.buscarEstoqueVirtual();
    this.buscarCategorias();
  }

  buscarCategorias() {
    this.carregandoService.mostra('buscarCategorias');
    this.categoriaService.listar().subscribe(categorias => {
      this.categorias = categorias;
      this.carregandoService.esconde('buscarCategorias');
    }, (erro) => {
      this.carregandoService.esconde('buscarCategorias');
      this.notificacaoService.erro(erro);
    });
  }

  async buscarIdCDPadrao() {
    try {
      this.carregandoService.mostra('buscarIdCDPadrao');
      const idCDPadrao = await this.funcionarioService.consultarIdCDPadrao().toPromise();
      if (idCDPadrao !== null && idCDPadrao !== undefined) {
        this.fornecedorSelecionado = idCDPadrao;
      }
      this.carregandoService.esconde('buscarIdCDPadrao');
    } catch (erro) {
      this.carregandoService.esconde('buscarIdCDPadrao');
      this.notificacaoService.erro(erro);
    }
  }

  async buscarMultiFornecedores() {
    try {
      this.carregandoService.mostra('consultarMultiFornecedores');
      this.multiFornecedores = (await this.premissasService.consultarMultiFornecedores().toPromise()).valor;
      this.carregandoService.esconde('consultarMultiFornecedores');
    } catch (erro) {
      this.carregandoService.esconde('consultarMultiFornecedores');
      this.notificacaoService.erro(erro);
    }
  }

  async buscarPremissaCentroDeDistribuicao() {
    try {
      this.carregandoService.mostra('buscarPremissaCentroDeDistribuicao');
      const cd = await this.premissasService.consultarCentroDeDistribuicao().toPromise();

      this.pCentroDistribuicao = cd.valor;

      this.carregandoService.esconde('buscarPremissaCentroDeDistribuicao');
    } catch (erro) {
      this.carregandoService.esconde('buscarPremissaCentroDeDistribuicao');
      this.notificacaoService.erro(erro);
    }
  }

  async buscarFornecedores() {
    try {
      this.carregandoService.mostra('buscarFornecedores');
      this.fornecedores = await this.fornecedorService.consultarFornecedores().toPromise();

      if (this.fornecedores !== null && this.fornecedores !== undefined && this.fornecedores.length > 0 && !this.fornecedorSelecionado) {
        this.fornecedorSelecionado = this.fornecedores[0].id;
      }

      this.carregandoService.esconde('buscarFornecedores');
    } catch (erro) {
      this.carregandoService.esconde('buscarFornecedores');
      this.notificacaoService.erro(erro);
    }
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.buscarProdutos();
    this.paginator.firstPage();
  }

  limpaFiltro() {
    this.filtroDescricao = "";
    this.filtroCodBarras = "";

    this.buscarProdutos();
  }

  exportar() {

    this.carregandoService.mostra('exportarProdutosEstoque');
    this.produtoService.exportarProdutosEstoque(this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc', this.filtroDescricao, this.mostrarCodErp ? '' : this.filtroCodBarras, this.statusSelecionado,
      this.familiaSelecionada, true, undefined, null, null, null, null, this.multiFornecedores || this.pCentroDistribuicao ? this.fornecedorSelecionado : undefined,
      null, null, null, null, null, null, null, null,
      null, true, null, null, this.mostrarCodErp ? this.filtroCodBarras : '', null, this.statusCDSelecionado, this.categoriaSelecionada).subscribe(arq => {
        this.utilitarioService.saveBlob(arq, 'Produtos_Estoque.xlsx');
        this.carregandoService.esconde('exportarProdutosEstoque');
      }, (erro) => {
        this.carregandoService.esconde('exportarProdutosEstoque');
        this.notificacaoService.erro(erro);
      });

  }

  buscarProdutos() {
    this.carregandoService.mostra('buscaProdutos');

    this.produtoService.consultarComPaginacao(this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc', this.filtroDescricao, this.mostrarCodErp ? '' : this.filtroCodBarras, this.statusSelecionado,
      this.familiaSelecionada, true, undefined, null, null, null, null, this.multiFornecedores || this.pCentroDistribuicao ? this.fornecedorSelecionado : undefined,
      null, null, null, null, null, null, null, null, null, true, null,
      null, null, this.mostrarCodErp ? this.filtroCodBarras : '', null, this.statusCDSelecionado, null, this.categoriaSelecionada).subscribe(dados => {
        this.produtosFiltrados = dados.itens;

        if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
          this.itensPorPagina = 10;
        }

        this.paginacao.total = dados.total;

        this.carregando = false;
        this.carregandoService.esconde('buscaProdutos');
      }, (erro) => {
        this.carregandoService.esconde('buscaProdutos');
        this.notificacaoService.erro(erro);
      });
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarProdutos();
  }

  fechar() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void { }

  buscarMostrarCodErp() {
    this.carregandoService.mostra('buscarMostrarCodErp');
    this.premissasService.consultarMostrarCodErp().subscribe(f => {
      this.mostrarCodErp = f.valor;
      this.carregandoService.esconde('buscarMostrarCodErp');
    }, (erro) => {
      this.carregandoService.esconde('buscarMostrarCodErp');
      this.notificacaoService.erro(erro);
    });
  }

  buscarEstoqueVirtual() {
    this.carregandoService.mostra('buscarEstoqueVirtual');
    this.premissasService.consultarEstoqueVirtual().subscribe(f => {
      this.estoqueVirtual = f.valor;
      this.carregandoService.esconde('buscarEstoqueVirtual');
    }, (erro) => {
      this.carregandoService.esconde('buscarEstoqueVirtual');
      this.notificacaoService.erro(erro);
    });
  }

  async buscarVendaProgramada() {
    try {
      this.carregandoService.mostra('buscarVendaProgramada');
      this.vendaProgramada = (await this.premissasService.consultarVendaProgramada().toPromise()).valor;
      this.carregandoService.esconde('buscarVendaProgramada');
    } catch (erro) {
      this.carregandoService.esconde('buscarVendaProgramada');
      this.notificacaoService.erro(erro);
    }
  }

  async buscarReservaManual() {
    try {
      this.carregandoService.mostra('buscarReservaManuak');
      this.reservaManual = (await this.premissasService.consultarUsarReservaManual().toPromise()).valor;
      this.carregandoService.esconde('buscarReservaManuak');
    } catch (erro) {
      this.carregandoService.esconde('buscarReservaManuak');
      this.notificacaoService.erro(erro);
    }
  }

  mostrarEstoqueDoProduto(produto: Produto) {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(EstoqueProdutoModalComponent, {
      width: largura > 830 ? '800px' : $('body').width().toString() + 'px',
      data: { produto, idFornecedor: this.fornecedorSelecionado },
      panelClass: 'modal-card',
    });
  }

  mostrarPedidos(produto: Produto) {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(PedidosLoteModalComponent, {
      width: largura > 1030 ? '1000px' : $('body').width().toString() + 'px',
      data: { tipo: 1, produto: produto, idFornecedor: this.fornecedorSelecionado },
      panelClass: 'modal-card',
    });
  }

  mostrarHistorico(produto: Produto) {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(HistoricoDoPrecoModalComponent, {
      width: $('body').width().toString() + 'px',
      data: { produto: produto, idFornecedor: this.fornecedorSelecionado },
      panelClass: 'modal-card',
    });
  }

  mostrarHistoricoEstoque(produto: Produto) {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(HistoricoEstoqueModalComponent, {
      width: $('body').width().toString() + 'px',
      data: { produto: produto, idFornecedor: this.fornecedorSelecionado },
      panelClass: 'modal-card',
    });
  }
}
